import React from "react"

const OverviewTab: React.FC<{ agent: any }> = ({ agent }) => {
    return (
        <div className="p-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* Agent Details */}
                <div className="lg:col-span-2">
                    <h3 className="text-lg font-semibold text-agentic-text-primary mb-4">Agent Details</h3>
                    <div className="space-y-4">
                        <div className="grid grid-cols-2 gap-4"> 
                            <div>
                                <label className="block text-sm font-medium text-agentic-text-secondary">Name</label>
                                <p className="mt-1 text-agentic-text-primary">{agent.name}</p>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-agentic-text-secondary">Type</label>
                                <p className="mt-1 text-agentic-text-primary capitalize">{agent.type.replace('-', ' ')}</p>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-agentic-text-secondary">Version</label>
                                <p className="mt-1 text-agentic-text-primary">{1 || agent.version}</p>
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-agentic-text-secondary">Department</label>
                            <p className="mt-1 text-agentic-text-primary">{agent?.department?.name}</p>
                        </div>
                        <div>
                            {/* <label className="block text-sm font-medium text-agentic-text-secondary">Capabilities</label>
                            <div className="mt-2 flex flex-wrap gap-2">
                                {agent.capabilities.map((capability: string, index: number) => (
                                    <span
                                        key={index}
                                        className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-agentic-primary-blue/10 text-agentic-primary-blue"
                                    >
                                        {capability}
                                    </span>
                                ))}
                            </div> */}
                            <label className="block text-sm font-medium text-agentic-text-secondary">State</label>
                            <p className="mt-1 text-agentic-text-primary">{(agent?.state as string)?.toUpperCase()}</p>
                        </div>
                         <div>
                                <label className="block text-sm font-medium text-agentic-text-secondary">Description</label>
                                <p className="mt-1 text-agentic-text-primary">{agent.description}</p>
                            </div>
                    </div>
                </div>

                {/* Status & Metrics */}
                <div>
                    <h3 className="text-lg font-semibold text-agentic-text-primary mb-4">Status & Metrics</h3>
                    <div className="space-y-4">
                        <div className="bg-agentic-gray-50 rounded-lg p-4">
                            <div className="flex items-center justify-between">
                                <span className="text-sm font-medium text-agentic-text-secondary">Status</span>
                                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${agent.status === 'active'
                                    ? 'bg-agentic-accent-green/10 text-agentic-accent-green'
                                    : 'bg-agentic-gray-200 text-agentic-text-secondary'
                                    }`}>
                                    {agent.status}
                                </span>
                            </div>
                        </div>
                        <div className="bg-agentic-gray-50 rounded-lg p-4">
                            <div className="flex items-center justify-between">
                                <span className="text-sm font-medium text-agentic-text-secondary">Total Interactions</span>
                                <span className="text-lg font-semibold text-agentic-text-primary">{agent.totalInteractions.toLocaleString()}</span>
                            </div>
                        </div>
                        {/* <div className="bg-agentic-gray-50 rounded-lg p-4">
                            <div className="flex items-center justify-between">
                                <span className="text-sm font-medium text-agentic-text-secondary">Success Rate</span>
                                <span className="text-lg font-semibold text-agentic-accent-green">{agent.successRate}%</span>
                            </div>
                        </div> */}
                        <div className="bg-agentic-gray-50 rounded-lg p-4">
                            <div className="flex items-center justify-between">
                                <span className="text-sm font-medium text-agentic-text-secondary">Avg Response Time</span>
                                <span className="text-lg font-semibold text-agentic-text-primary">{agent.avgResponseTime}s</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OverviewTab;
